<template>
  <div style="width: 100%;height: 100%;background: url('../static/background.jpg') center center / cover no-repeat;">
    <div style="width:400px;padding:20px;border-radius: 5px;background:rgb(255,255,255);top: 50%;right:0;position: absolute;transform: translate(-40%,-50%);z-index: 99;opacity: 0.75;
display: flex;flex-flow: column;align-items: center;justify-content: center">
      <div style="width: 100px;height: 100px;position: absolute;top: -50px;left:150px;background:rgba(255,255,255,1);border-top-left-radius: 50%;">
        <img src="/static/logo.png" style="max-width: 100%">
      </div>
      <div id="code-login" style="display: flex;justify-content: center;margin-top: 40px;"></div>
      <div style="width: 100%;text-align: center;font-size: 18px;margin-bottom: 20px;">请使用飞书扫码进入</div>
      <a :href="FeiShuUrl" style="padding: 8px 20px;border: 1px solid #000000;border-radius: 5px;cursor: pointer;color: #6c51e5">
        飞书授权登陆
      </a>
    </div>
    <div style="width: 100%;position: absolute;bottom: 0;background:rgba(255,255,255,0.25);text-align: center;padding: 5px 0;
    font-size: 16px;color: #FFFFFF">
      <div>Copyright © 2023 GameBrain DataCenter</div>
      <div>武汉哈乐沃德网络科技有限公司</div>
    </div>
    <div style="position:absolute;top: 35%;padding: 10px 15px;background: rgba(255,255,255,0.3);font-size: 32px;font-weight: bolder;color: #ffffff;">
      <div style="font-size: 48px;">GameBrain DataCenter</div>
      <div style="text-align: right">稳定 准确 安全 高效 便捷</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data(){
    return {
      login_url:"https://datacenter.gamebrain.io/codeLogin",
      STATE:1,
      FeiShuUrl:""
    }
  },
  mounted() {

    // localStorage.setItem("user_id",122)
    // localStorage.setItem("user_token",'f31673c5f0db908b5f476a74683bfcbe')
    this.init_code_login()
  },
  methods:{
    init_code_login(){
      document.getElementById('code-login').innerHTML = ''
      if (typeof window.addEventListener != 'undefined') {
        window.removeEventListener('message', handleMessage, false);}
      else if (typeof window.attachEvent != 'undefined') {
        window.detachEvent('onmessage', handleMessage);
      }
      let _login_url = this.login_url
      let STATE = this.STATE
      this.FeiShuUrl = "https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a1b409d6b6fb100c&redirect_uri="+_login_url+"&response_type=code&state="+STATE

      var QRLoginObj = QRLogin({
        id:"code-login",
        goto: this.FeiShuUrl,
        width: "300",
        height: "300",
      });
      var handleMessage = function (event) {
        var origin = event.origin;
        // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
        if( QRLoginObj.matchOrigin(origin) ) {
          var loginTmpCode = event.data;
          // 在授权页面地址上拼接上参数 tmp_code，并跳转
          window.location.href = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a1b409d6b6fb100c&redirect_uri=${_login_url}&response_type=code&state=${STATE}&tmp_code=${loginTmpCode}`
        }
      };
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false);}
      else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage);
      }
    }
  }
}
</script>

<style>
#code-login iframe{
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue